import { initialErrors } from "../Constants/CartGifts.constants";
import { Types } from "../Constants/Types";
import { CartGiftType } from "../Interfaces/cart-gifts.interface";

const CartGiftsReducer = (
  state: CartGiftType["status"] = {
    cartGift: undefined,
    cartGifts: [],
    results: [],
    lcartGifts: false,
    lupdate: false,
    pages: 0,
    resultPages: 0,
    error: initialErrors,
  },
  action: CartGiftType["action"]
) => {
  switch (action.type) {
    case Types.SEARCH_CART_GIFTS:
      return { ...state, results: action.payload, resultPages: action.pages };

    case Types.FETCH_CART_GIFTS:
      return { ...state, cartGifts: action.payload, pages: action.pages };

    case Types.FETCH_CART_GIFT:
      return { ...state, cartGift: action.payload };

    case Types.CREATE_CART_GIFT:
      return { ...state, cartGifts: [action.payload, ...state.cartGifts] };

    case Types.UPDATE_CART_GIFT:
      return {
        ...state,
        cartGifts: state.cartGifts.map((cartGift) =>
          cartGift._id === action.payload.id ? action.payload : cartGift
        ),
      };

    case Types.STATE_CART_GIFT:
      return {
        ...state,
        cartGifts: state.cartGifts.map((cartGift) =>
          cartGift._id === action.payload.id
            ? { ...cartGift, ...action.payload }
            : cartGift
        ),
        cartGift: { ...state.cartGift, state: action.payload.state },
      };

    case Types.POSITION_CART_GIFT:
      return {
        ...state,
        cartGifts: state.cartGifts.map((cartGift) =>
          cartGift._id === action.payload.id
            ? { ...cartGift, position: action.payload.position }
            : cartGift
        ),
      };

    case Types.DELETE_CART_GIFT:
      return {
        ...state,
        cartGifts: state.cartGifts.filter(
          (cartGift) => cartGift._id !== action.payload
        ),
      };

    case Types.START_CART_GIFTS:
      return { ...state, lcartGifts: true };

    case Types.END_CART_GIFTS:
      return { ...state, lcartGifts: false };

    case Types.START_CART_GIFT:
      return { ...state, lupdate: true };

    case Types.END_CART_GIFT:
      return { ...state, lupdate: false };

    case Types.ERROR_CART_GIFT:
      return {
        ...state,
        error: action?.payload
          ? { ...state.error, [action?.field!]: action.payload }
          : { ...state.error, [action?.field!]: null },
      };

    case Types.RESET_CART_GIFT:
      return { ...state, error: initialErrors };

    default:
      return state;
  }
};

export default CartGiftsReducer; 